'use strict'
let baseUrl = process.env.API;
import axios from 'axios'
import qs from 'qs'
import elementui from 'element-ui'
import Vue from 'vue'
Vue.use(elementui)
let vue = new Vue()
axios.interceptors.request.use(config => {
  // loading
  return config
}, error => {
  return Promise.reject(error)
})
axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.resolve(error.response)
})
function stringify(params){
  var str = "";
  for(var key in params){
    str += key + "=" + params[key] + "&";
  }
  return str;
};
function formify(params){
  var formData =new FormData();
  for(var key in params){
    formData.append(key,params[key]);
  }
  return formData;
};
function checkCode (res,obj) {
  let that=this;
  if(res.status === 200){
    if(obj.baseURL == baseUrl && res.data.code == 0 && (!res.data.item) && (!res.data.mapData) && (!res.data.rows)){
      if(typeof obj.error == 'function'){
        obj.error(res.data);
      }else {
        vue.$message({
          type: 'error',
          duration: 4000,
          message: res.data.message||"执行方法出错！请联系我们！",
        });
      }
    }else {
      if(typeof obj.success == 'function'){
        obj.success(res.data);
      }
    }
  }else {
    if(typeof obj.fail == 'function'){
      obj.fail(res);
    }else {

      if (res.status === 404) {
        vue.$message.error("请求错误！请联系我们！");
        return;
      } else if (res.status === 401 || res.status === 403) {
        window.location.href = "/v/login";
        return;
      } else if (res.status === 406) {
        //跳到协议页
        window.location.href = "/protocol?site="+res.data.mapData.site;
        return;
      } else if (res.status === 999) {//vnetshop没有登录
        localStorage.setItem('preVnetshopPage', window.location.href);
        window.location.href = res.data.mapData.loginUrl;
        return;
      } else if(res.status === 307){
        window.location.href = res.data.mapData.authorUrl;
        return;
      } else {
        vue.$message.error("网络错误！请稍后再试！");
      }
    }
  }
  return res
}
export default {
  execute (obj) {
    let method = obj.method || 'post';
    let baseURL = obj.baseURL || baseUrl; //定义成全局变量
    let timeout = obj.timeout || 30000;
    let type = obj.type || 'json';
    obj.baseURL = baseURL;
    let headers = { };
    if(method.toLowerCase() == 'upload'){
      headers['Content-Type'] =  'multipart/form-data';
      method = 'post';
    }else if(method.toLowerCase() == 'post'){
      headers['X-Requested-With'] = 'XMLHttpRequest';
      if(type.toLowerCase() == 'form'){
        if(obj.params){
          obj.params = formify(obj.params);
        }
        headers['Content-Type'] =  'application/x-www-form-urlencoded';
      }else {
        headers['Content-Type'] =  'application/json; charset=UTF-8';
      }
    }else if(method.toLowerCase() == 'get'){
      headers['X-Requested-With'] = 'XMLHttpRequest';
      if(obj.params){
        obj.url = obj.url + "?" + stringify(obj.params)
      }
    }
    return axios({
      method: method,
      baseURL: baseURL,
      url: obj.url,
      data: obj.params||{},
      timeout: timeout,
      headers: headers
    }).then(
      (res) => {
        if(res.headers.hbt_datalimits || res.headers.hbt_datalimits == '0'){
          sessionStorage.setItem('hbt_dataLimits', res.headers.hbt_datalimits);
        }
      if(typeof obj.complete == 'function'){
        obj.complete(res);
      }
      if(!res){
        res = {status: 408, statusText: '请求超时！',data: {code: 0, message: '请求超时！'}};
      }
      return checkCode(res,obj)
    }).catch(function (res) {
      if(typeof obj.fail == 'function'){
        obj.fail(res);
      }
    })
  },
  //post请求
  post (url, data) {
    return axios({
      method: 'post',
      baseURL: 'http://192.168.2.20',
      url: url,
      data: data,
      timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  //get请求
  get (url, params) {
    return axios({
      method: 'get',
      baseURL: 'https://cnodejs.org/api/v1',
      url,
      params, // get 请求时带的参数
      timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
}



// WEBPACK FOOTER //
// ./src/utils/http.js